function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
import { createSelector } from 'reselect';
import { currency } from '../../helpers/numberFormatter';
import { dateFilter } from '../../helpers/orderHistoryFilters';
import { formValueSelector } from 'redux-form';
import { selectedInstrumentSelector } from './instrumentPositionSelectors';
var formSelector = formValueSelector('order-history-filter');
var openOrdersCurrencySelector = createSelector([function (state) {
  return state.apexCore.orderHistory.openOrders;
}, function (state) {
  return state.apexCore.instrument.instruments;
}, function (state) {
  return state.apexCore.orderHistory.tradeReports;
}], convertOrderNumbersToCurrency);
var trailingOrdersSelectorFactory = function trailingOrdersSelectorFactory(ordersSelector) {
  return createSelector(ordersSelector, function (orders) {
    return orders.map(function (order) {
      if (order.OrderType === 'TrailingStopLimit' || order.OrderType === 'TrailingStopMarket') {
        return Object.assign({}, order, {
          trailingPrice: 'TRL'
        });
      }
      return order;
    });
  });
};
export var openOrdersSelector = createSelector(openOrdersCurrencySelector, function (orders) {
  return orders.filter(function (order) {
    return order.OrderState !== 'FullyExecuted' && order.OrderState === 'Working';
  }).sort(function (a, b) {
    return b.ReceiveTime - a.ReceiveTime;
  });
});
export var openOrdersSelectorFactory = function openOrdersSelectorFactory() {
  return createSelector([trailingOrdersSelectorFactory(openOrdersSelector), function (state) {
    return state.apexCore.position.selectedProductId;
  }, selectedInstrumentSelector, function (state) {
    return state.apexCore.instrument.instruments;
  }, function (state) {
    return formSelector(state, 'startDate', 'endDate');
  }, function (state, props) {
    return props.filterMode;
  }], function (orders, selectedProductId, selectedInstrument, instruments, formValues, filterMode) {
    var selectedInstrumentId = selectedInstrument.InstrumentId;
    if (filterMode === 'selectedProduct') {
      var filteredOrders = orders;
      if (selectedProductId) {
        filteredOrders = filterOrdersByProductId(orders, selectedProductId, instruments);
      }
      return filterOrdersByDate(filteredOrders, formValues, 'ReceiveTime');
    } else {
      // else filterMode == 'selectedInstrument'
      return orders.filter(function (order) {
        return order.Instrument === selectedInstrumentId;
      });
    }
  });
};
export var buyOpenOrdersSelector = createSelector(openOrdersSelectorFactory(), function (orders) {
  return orders.filter(function (order) {
    return order.Side === 'Buy' && order.OrderType !== 'BlockTrade';
  });
});
export var sellOpenOrdersSelector = createSelector(openOrdersSelectorFactory(), function (orders) {
  return orders.filter(function (order) {
    return order.Side === 'Sell' && order.OrderType !== 'BlockTrade';
  });
});
var accountTradesCurrencySelector = createSelector([function (state) {
  return state.apexCore.orderHistory.accountTrades;
}, function (state) {
  return state.apexCore.instrument.instruments;
}, function (state) {
  return state.apexCore.product.products;
}], function (trades, instruments, products) {
  return trades.map(function (trade) {
    var instrument = instruments.find(function (item) {
      return item.InstrumentId === trade.InstrumentId;
    });
    if (!instrument) return {};
    var Product1Symbol = instrument.Product1Symbol,
      Product2Symbol = instrument.Product2Symbol;
    var quantity = currency(trade.Quantity, Product1Symbol);
    var price = currency(trade.Price, Product2Symbol);
    var symbol = trade.Side === 'Buy' ? Product1Symbol : Product2Symbol;
    var value = currency(trade.Value, symbol);
    var feeProduct = products.find(function (p) {
      return p.ProductId === trade.FeeProductId;
    });
    var fee = currency(trade.Fee, feeProduct ? feeProduct.Product : symbol);
    return Object.assign({}, trade, {
      Quantity: quantity,
      Price: price,
      Value: value,
      Fee: fee
    });
  });
});
var filledOrdersSelector = createSelector(accountTradesCurrencySelector, function (trades) {
  return trades.filter(function (trade) {
    return !trade.IsBlockTrade;
  }).sort(function (a, b) {
    if (a.TradeTime < b.TradeTime) return 1;
    if (a.TradeTime > b.TradeTime) return -1;
    return 0;
  });
});
export var filledOrdersSelectorFactory = function filledOrdersSelectorFactory() {
  return createSelector([trailingOrdersSelectorFactory(filledOrdersSelector), function (state) {
    return state.apexCore.position.selectedProductId;
  }, selectedInstrumentSelector, function (state) {
    return state.apexCore.instrument.instruments;
  }, function (state) {
    return formSelector(state, 'startDate', 'endDate');
  }, function (state, props) {
    return props.filterMode;
  }], function (orders, selectedProductId, selectedInstrument, instruments, formValues, filterMode) {
    var selectedInstrumentId = selectedInstrument.InstrumentId;
    if (filterMode === 'selectedProduct') {
      var filteredOrders = orders;
      if (selectedProductId) {
        filteredOrders = filterOrdersByProductId(orders, selectedProductId, instruments);
      }
      return filterOrdersByDate(filteredOrders, formValues, 'TradeTimeMS');
    } else {
      // else filterMode == 'selectedInstrument'
      return orders.filter(function (order) {
        return order.InstrumentId === selectedInstrumentId;
      });
    }
  });
};
var inactiveOrdersCurrencySelector = createSelector([function (state) {
  return state.apexCore.orderHistory.inactiveOrders;
}, function (state) {
  return state.apexCore.instrument.instruments;
}], convertOrderNumbersToCurrency);
var inactiveOrdersSelector = createSelector(inactiveOrdersCurrencySelector, function (orders) {
  return orders.filter(function (order) {
    return order.OrderState !== 'FullyExecuted' && order.OrderState !== 'Working';
  }).sort(function (a, b) {
    return b.ReceiveTime - a.ReceiveTime;
  });
});
export var inactiveOrdersSelectorFactory = function inactiveOrdersSelectorFactory() {
  return createSelector([trailingOrdersSelectorFactory(inactiveOrdersSelector), function (state) {
    return state.apexCore.position.selectedProductId;
  }, selectedInstrumentSelector, function (state) {
    return state.apexCore.instrument.instruments;
  }, function (state) {
    return formSelector(state, 'startDate', 'endDate');
  }, function (state, props) {
    return props.filterMode;
  }], function (orders, selectedProductId, selectedInstrument, instruments, formValues, filterMode) {
    var selectedInstrumentId = selectedInstrument.InstrumentId;
    if (filterMode === 'selectedProduct') {
      var filteredOrders = orders;
      if (selectedProductId) {
        filteredOrders = filterOrdersByProductId(orders, selectedProductId, instruments);
      }
      return filterOrdersByDate(filteredOrders, formValues, 'ReceiveTime');
    } else {
      // else filterMode == 'selectedInstrument'
      return orders.filter(function (order) {
        return order.Instrument === selectedInstrumentId;
      });
    }
  });
};
function convertOrderNumbersToCurrency(orders, instruments) {
  var tradeReports = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var allOrders = [].concat(_toConsumableArray(orders), _toConsumableArray(tradeReports));
  return allOrders.filter(function (order) {
    return !!order;
  }).map(function (order) {
    var instrument = instruments.find(function (item) {
      return item.InstrumentId === order.Instrument;
    });
    if (!instrument) {
      return order;
    }
    var Product1Symbol = instrument.Product1Symbol,
      Product2Symbol = instrument.Product2Symbol;
    var quantity = currency(order.Quantity, Product1Symbol);
    var origQuantity = currency(order.OrigQuantity, Product1Symbol);
    var price = currency(order.Price, Product2Symbol);
    return Object.assign({}, order, {
      quantity: quantity,
      OrigQuantity: origQuantity,
      Price: price
    });
  });
}
var tradeReportsCurrecnySelector = createSelector([function (state) {
  return state.apexCore.orderHistory.tradeReports;
}, function (state) {
  return state.apexCore.instrument.instruments;
}], function (tradeReports, instruments) {
  var trades = tradeReports.filter(function (order) {
    return order.OrderState !== 'Working';
  });
  trades.map(function (order) {
    var instrument = instruments.find(function (item) {
      return item.InstrumentId === order.InstrumentId || order.Instrument;
    });
    var Product1Symbol = instrument.Product1Symbol,
      Product2Symbol = instrument.Product2Symbol;
    var quantity = currency(order.Quantity, Product1Symbol);
    var price = currency(order.Price, Product2Symbol);
    var symbol = order.Side === 'Buy' ? Product1Symbol : Product2Symbol;
    var fee = currency(order.Fee, symbol);
    return Object.assign({}, order, {
      Quantity: quantity,
      Price: price,
      Fee: fee
    });
  });
  return trades;
});
var tradeReportsSelector = createSelector([tradeReportsCurrecnySelector, accountTradesCurrencySelector], function (tradeReports, accountTrades) {
  var blockTrades = accountTrades.filter(function (trade) {
    return trade.IsBlockTrade;
  });
  return tradeReports.concat(blockTrades).map(function (order) {
    return Object.assign({}, order, {
      SortingTime: order.ReceiveTimeTicks ? order.ReceiveTimeTicks : order.TradeTime
    });
  }).sort(function (a, b) {
    if (a.SortingTime < b.SortingTime) return 1;
    if (a.SortingTime > b.SortingTime) return -1;
    return 0;
  });
});
export var tradeReportsSelectorFactory = function tradeReportsSelectorFactory() {
  return createSelector([trailingOrdersSelectorFactory(tradeReportsSelector), function (state) {
    return state.apexCore.position.selectedProductId;
  }, selectedInstrumentSelector, function (state) {
    return state.apexCore.instrument.instruments;
  }, function (state) {
    return formSelector(state, 'startDate', 'endDate');
  }, function (state, props) {
    return props.filterMode;
  }], function (orders, selectedProductId, selectedInstrument, instruments, formValues, filterMode) {
    var selectedInstrumentId = selectedInstrument.InstrumentId;
    if (filterMode === 'selectedProduct') {
      var filteredOrders = orders;
      if (selectedProductId) {
        filteredOrders = filterOrdersByProductId(orders, selectedProductId, instruments);
      }
      return filterOrdersByDate(filteredOrders, formValues, 'TradeTimeMS');
    } else {
      // else filterMode == 'selectedInstrument'
      return orders.filter(function (order) {
        return order.InstrumentId === selectedInstrumentId || order.Instrument === selectedInstrumentId;
      });
    }
  });
};
function filterOrdersByProductId(orders, selectedProductId, instruments) {
  var ordersWithProductIds = orders.map(function (order) {
    var instrument = instruments.find(function (item) {
      return item.InstrumentId === order.Instrument || item.InstrumentId === order.InstrumentId;
    });
    return Object.assign({}, order, {
      product1Id: instrument ? instrument.Product1 : null,
      product2Id: instrument ? instrument.Product2 : null
    });
  });
  return ordersWithProductIds.filter(function (order) {
    return order.product1Id === selectedProductId || order.product2Id === selectedProductId;
  });
}
function filterOrdersByDate(orders, formValues, timeStamp) {
  return orders.filter(function (item) {
    return dateFilter(item, formValues.startDate, formValues.endDate, timeStamp);
  });
}